module.exports = __webpack_public_path__ + "img/46_21.93b392ab.png";